import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { Role } from 'src/app/models/role.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
 
 gnBaseURL: any;
  constructor(private http: HttpClient,private appURL: AppConfigService) {
    this.gnBaseURL=this.appURL.getServerUrl();
  }

  getAllRoleType(): Observable<Role[]> {

    return this.http.get<Role[]>(this.gnBaseURL + 'Role');

  }
}
